module.exports = __webpack_public_path__ + "static/media/user-cog.12e71b82.svg";